import { useParams } from 'react-router-dom'
import { Message } from 'semantic-ui-react'
import { Helmet } from 'react-helmet'
import * as React from 'react'

import FunnelBoard from '../../components/funnels/FunnelBoard'
import PageLoader from '../../components/pageLoader'
import useFunnel from '../../hooks/useFunnel'
import FunnelFilters from '../../components/funnels/FunnelFilters'
import FunnelHeader from '../../components/funnels/FunnelHeader'

export default function FunnelPage() {
  const { funnelName } = useParams<{ funnelName: string }>()

  if (!funnelName) {
    throw new Error('`funnelName` param must be present in the URL')
  }

  const { data, isLoading, error } = useFunnel(funnelName)

  if (isLoading) return <PageLoader />

  if (!data || error) {
    return (
      <Message error>
        Funnel <code>{funnelName}</code> not found.
      </Message>
    )
  }

  return (
    <div className="relative flex h-screen flex-col">
      <Helmet>
        <title>{data.funnel.title} - Rome</title>
      </Helmet>

      <FunnelFilters funnel={data.funnel} cards={data.cards}>
        {({ filteredCards, filtersElement }) => (
          <>
            <FunnelHeader
              funnel={data.funnel}
              filtersElement={filtersElement}
            />

            <FunnelBoard
              funnel={data.funnel}
              cards={filteredCards}
              key={data.funnel._id}
            />
          </>
        )}
      </FunnelFilters>
    </div>
  )
}
